module.exports = __webpack_public_path__ + "static/media/questionmark.70d1e8c4.png";